/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { debounce } from 'lodash';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';

// Constants
const INPUT_DEBOUNCE_TIME = 300;

/**
 * This component is used to populate and validate the container app name.
 *
 * Beside the `type` param, it has all `BaseControl` options.
 *
 * @example
 *
 * container-picker(:label="t('name')" v-model="form.appname" name="branding")
 *
 * @category ui.components.form-elements.pickers
 * @exports ContainerPicker
 */
const __vue_script__ = {
    name: 'ContainerPicker',

    extends: BaseControl,

    props: {
        baseUrl: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            debounceInput: debounce($event => this.input($event), INPUT_DEBOUNCE_TIME),
            innerValue: this.value
        };
    },

    computed: {
        /** @returns {string} */
        urlPreview() {
            if (this.innerValue) {
                return `${this.baseUrl}${this.innerValue}`;
            }
            return this.baseUrl;
        }
    },

    methods: {
        /**
         * User input event handler
         */
        async input($event) {
            this.innerValue = $event.target.value;
            await this.$refs.provider.validate($event);
            this.$emit('input', this.innerValue);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{ref:"provider",attrs:{"rules":"required|alpha_dash|unique_container","slim":true,"name":_vm.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('control-decorator',{attrs:{"label":_vm.label,"tip":_vm.tip,"hint":_vm.hint || _vm.urlPreview,"uid":_vm.uid,"errors":errors,"warning":_vm.warning,"dependant":_vm.dependant}},[_c('div',{staticClass:"input-wrapper",class:{'with-content': _vm.$slots.default}},[_c('input',_vm._b({ref:"input",staticClass:"form-control",class:{'has-error': errors.length, 'has-warning': _vm.warning},attrs:{"id":_vm.uid,"name":_vm.name,"type":"text","disabled":_vm.disabled,"autocomplete":_vm.autocomplete,"placeholder":_vm.placeholder},on:{"input":_vm.debounceInput}},'input',_vm.$attrs,false)),_vm._t("default")],2)])]}}],null,true)})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ContainerPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__